<template>
    <div class="video-player">
        <div class="video-player__title">{{ channelName }}</div>
        <div class="video-box">
            <video ref="videoPlayer" controls></video>
        </div>
    </div>
</template>

<script>
import Hls from 'hls.js'

export default {
    name: 'VideoPlayerHls',
    props: {
        channelName: {
            type: String,
            required: true
        },
        url: {
            type: String,
            required: true
        },
        isLive: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    mounted () {
        const video = this.$refs.videoPlayer

        // Check if Hls.js is supported
        if (Hls.isSupported()) {
            const hls = new Hls()
            hls.loadSource(this.url)
            hls.attachMedia(video)
            hls.on(Hls.Events.MANIFEST_PARSED, () => {
                video.play()
            })

            // Error handling
            hls.on(Hls.Events.ERROR, (event, data) => {
                if (data.fatal) {
                    switch (data.fatal) {
                        case Hls.ErrorTypes.NETWORK_ERROR:
                            console.error('Network error, trying to reload...')
                            hls.startLoad() // Retry loading the stream
                            break
                        case Hls.ErrorTypes.MEDIA_ERROR:
                            console.error('Media error, trying to recover...')
                            hls.recoverMediaError() // Try to recover media error
                            break
                        case Hls.ErrorTypes.OTHER_ERROR:
                            console.error('Other error, destroying HLS instance...')
                            hls.destroy() // Clean up HLS instance
                            break
                        default:
                            console.error('Unhandled error:', data)
                            break
                    }
                }
            })

            this.$once('hook:beforeDestroy', () => {
                if (hls) {
                    hls.destroy()
                }
            })
        } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
            video.src = this.url
            video.addEventListener('loadedmetadata', () => {
                video.play()
            })
        }
    }
}
</script>

<style scoped lang="scss">
.video-player {
    padding: 10px 5px;
    width: 100%;

    &__title {
        text-align: center;
        background: $secondary;
        color: white;
        padding: 13px 0;
        font-weight: bold;
    }

    .video-box {
        video {
            width: 100% !important;
            height: 350px !important;
        }
    }
}
</style>
